<style>
	@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Device Renewal" title="All Devices" />

		<div class="container-fluid">
			<div class="card">
				<div class="card-body">
					<div class="col-md-12 project-list filter-sort">
						<div class="row">
							<div class="col-md-8 d-flex">
								<label class="d-flex listing-length"><span>Show</span>
									<select class="form-select" v-model="listing_length" @change="fetchDevices()">
										<option value="10">10</option>
										<option value="20">20</option>
										<option value="50">50</option>
										<option value="100">100</option>
										<option value="200">200</option>
									</select>
									<span>entries</span>
								</label>
							</div>

							<div class="col-md-2">
								<select class="form-select" v-model="type" @change="fetchDevices()">
									<option value="1">All</option>
									<option value="2">Expired</option>
								</select>
							</div>
							<div class="col-md-2">
								<input
									type="text"
									class="form-control"
									placeholder="Search IMEI"
									v-model="imei"
									@input="onImeiSearch"
								/>
							</div>
						</div>
					</div>

					<div class="table-responsive product-table">
						<table class="display" id="all-devices-table">
							<thead>
								<tr align="center">
									<th>Sl.No</th>
									<th>Device Details</th>
									<th>Dealer</th>
									<th>Enquired Dealer</th>
									<th>Renewal Status</th>
									<th>Request Status</th>
									<th>Enquiry Status</th>
									<th>Customer Info</th>
									<th>Dealer Info</th>
                                    <th>Action</th>
								</tr>
							</thead>
							<tbody v-if="devices.length">
								<tr v-for="(device, index) in devices" :key="device.device_id" align="center">
									<td>{{ (from - 1) + index + 1 }}</td>
									<td><b>IMEI:-</b>{{ device.uniqueid }} <br> 
										<b>ICCID:-</b>{{ device.iccid }} <br>
										<b>Vehicle No:-</b>{{ device.vehicle_no || '-' }}<br>
										<b>Expire:-</b>{{ device.expirationtime ? $filters.formatDateTime(device.expirationtime) : '-' }}<br>
									</td>
									<td>{{ device.dealer_name || '-' }}</td>
									<td>{{ device.enquired_dealer_name || '-' }}</td>
									<td>
										<span v-if="device.status == 1" class="badge rounded-pill bg-success">Renewed</span>
										<span v-else-if="device.status == 2" class="badge rounded-pill bg-info">Pending</span>
										<span v-else-if="device.status == 3" class="badge rounded-pill bg-warning">Enquiry</span>
										<span v-else-if="device.status == 4" class="badge rounded-pill bg-primary">Recharge Requested</span>
										<span v-else-if="device.status == 5" class="badge rounded-pill bg-success">Recharge Completed</span>

										<span v-if="device.expiry_soon == 1" class="badge rounded-pill bg-secondary mt-2">Expire Soon</span>
									</td>
									<td>
										<span v-if="device.request_status == 1" class="badge rounded-pill bg-success">Requested</span>
										<span v-else-if="device.request_status == 2" class="badge rounded-pill bg-warning">Pending</span>
										<span v-else class="badge rounded-pill bg-secondary">-</span>
									</td>
									<td>
										<span v-if="device.is_enquiry == 1" class="badge rounded-pill bg-success">Enquired</span>
										<span v-else-if="device.is_enquiry == 2" class="badge rounded-pill bg-warning">Pending</span>
										<span v-else class="badge rounded-pill bg-secondary">-</span>
									</td>
									<td>
										<span v-if="device.customer_info == 0" class="badge rounded-pill bg-warning">Pending</span>
										<span v-else-if="device.customer_info == 1" class="badge rounded-pill bg-info">Attended</span>
										<span v-else-if="device.customer_info == 2" class="badge rounded-pill bg-success">Completed</span>
										<span v-else class="badge rounded-pill bg-secondary">-</span>
										<span v-if="device.customer_info == 1 || device.customer_info == 2">
											<b>Info By:-</b> {{ device.customer_info_by_name || '-' }}<br>
											<b>Info On:-</b> {{ device.customer_info_on ? $filters.formatDateTime(device.customer_info_on) : '-' }}<br>
											<b>Remarks:-</b> {{ device.customer_info_notes || '-' }}<br>
										</span>
									</td>
									<td>
										<span v-if="device.dealer_info == 0" class="badge rounded-pill bg-warning">Pending</span>
										<span v-else-if="device.dealer_info == 1" class="badge rounded-pill bg-info">Attended</span>
										<span v-else-if="device.dealer_info == 2" class="badge rounded-pill bg-success">Completed</span>
										<span v-else class="badge rounded-pill bg-secondary">-</span>
										<span v-if="device.dealer_info == 1 || device.dealer_info == 2">
											<b>Info By:-</b> {{ device.dealer_info_by_name || '-' }}<br>
											<b>Info On:-</b> {{ device.dealer_info_on ? $filters.formatDateTime(device.dealer_info_on) : '-' }}<br>
											<b>Remarks:-</b> {{ device.dealer_info_notes || '-' }}<br>
										</span>
									</td>
									<td>
                                        <a class="btn btn-secondary btn-sm me-2 mb-2" @click="sendEnquiry(device)"  v-if="device.is_enquiry != 1 && device.request_status != 1">Enquiry</a>
										<!-- <router-link :to="{ name: 'recharge_device', params: { device_id: device.device_id } }" class="btn btn-warning btn-sm me-2 mb-2" v-if="device.recharge_status == 2 && ![1, 4, 5].includes(device.status)">Request Recharge</router-link> -->
										<router-link :to="{ name: 'recharge_device', params: { device_id: device.device_id } }" class="btn btn-warning btn-sm me-2 mb-2" v-if="device.request_status == 2 && device.expiry_soon == 1">Request Recharge</router-link>
										<a class="btn btn-info btn-sm me-2 mb-2" @click="customerInfo(device)" v-if="(device.status == 1 || device.status == 2)">Customer Info</a>
										<a class="btn btn-primary btn-sm me-2 mb-2" @click="dealerInfo(device)" v-if="(device.status == 1 || device.status == 2)">Dealer Info</a><br>
										<router-link v-if="device.log_data == 1" :to="{ name: 'renewal_logs', params: { id: device.renewal_id } }" class="btn btn-success btn-sm me-2 mb-2">Renewal Logs</router-link>
									    <button
											type="button"
											class="btn btn-danger btn-sm me-2 mb-2"
											v-if="canShowExtension(device)"
											@click="confirmExtension(device)"
										>Extension</button>
										<button
											type="button"
											class="btn btn-dark btn-sm me-2 mb-2"
											v-if="canShowTopup(device)"
											@click="confirmTopup(device)"
										>Topup</button>
									</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td colspan="11" align="center">No data available</td>
								</tr>
							</tbody>
						</table>
					</div>

					<caption v-if="devices.length" class="float-start mt-2 d-block d-lg-inline">
						Showing {{ from }} to {{ to }} of {{ total }} entries
					</caption>
					<nav aria-label="Page navigation" class="mt-2 float-end">
						<ul class="pagination">
							<li
								class="page-item"
								v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
								v-for="(page, index) in pagination"
								:key="page.label"
							>
								<a
									class="page-link"
									href="#"
									@click.prevent="fetchDevices(buildPageUrl(page.url))"
									tabindex="-1"
								>
									<span v-if="index === 0">Prev</span>
									<span v-else-if="index === pagination.length - 1">Next</span>
									<span v-else>{{ page.label }}</span>
								</a>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</div>

		<!-- Customer Info Modal -->
		<div class="modal fade" id="customerInfoModal" tabindex="-1" aria-labelledby="customerInfoModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="customerInfoModalLabel">Customer Info</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="submitCustomerInfo" v-if="customerInfoDevice">
							<div class="row mb-3">
								<div class="col-md-12">
									<div class="alert alert-light border">
										<strong>Device:</strong> {{ customerInfoDevice.uniqueid }}<br>
										<strong>Vehicle:</strong> {{ customerInfoDevice.vehicle_no || '-' }}<br>
										<strong>Dealer:</strong> {{ customerInfoDevice.dealer_name || '-' }}
									</div>
								</div>
							</div>
							<div class="row mb-2">
								<div class="col-md-12 form-group">
									<label class="control-label">Notes</label>
									<textarea v-model="customerInfoForm.notes" class="form-control" rows="3" placeholder="Enter notes..."></textarea>
								</div>
							</div>
							<div class="row mb-3">
								<div class="col-md-12 form-group">
									<label class="control-label">Status</label>
									<select v-model.number="customerInfoForm.status" class="form-select">
										<option :value="0">Pending</option>
										<option :value="1">Attended</option>
										<option :value="2">Completed</option>
									</select>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<button type="submit" class="btn btn-primary me-2" :disabled="customerInfoSubmitting">
										<span v-if="customerInfoSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
										{{ customerInfoSubmitting ? "Saving..." : "Submit" }}
									</button>
									<button type="button" class="btn btn-light" @click="closeCustomerInfoModal">Close</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<!-- Dealer Info Modal -->
		<div class="modal fade" id="dealerInfoModal" tabindex="-1" aria-labelledby="dealerInfoModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="dealerInfoModalLabel">Dealer Info</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="submitDealerInfo" v-if="dealerInfoDevice">
							<div class="row mb-3">
								<div class="col-md-12">
									<div class="alert alert-light border">
										<strong>Device:</strong> {{ dealerInfoDevice.uniqueid }}<br>
										<strong>Vehicle:</strong> {{ dealerInfoDevice.vehicle_no || '-' }}<br>
										<strong>Dealer:</strong> {{ dealerInfoDevice.dealer_name || '-' }}
									</div>
								</div>
							</div>
							<div class="row mb-2">
								<div class="col-md-12 form-group">
									<label class="control-label">Notes</label>
									<textarea v-model="dealerInfoForm.notes" class="form-control" rows="3" placeholder="Enter notes..."></textarea>
								</div>
							</div>
							<div class="row mb-3">
								<div class="col-md-12 form-group">
									<label class="control-label">Status</label>
									<select v-model.number="dealerInfoForm.status" class="form-select">
										<option :value="0">Pending</option>
										<option :value="1">Attended</option>
										<option :value="2">Completed</option>
									</select>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<button type="submit" class="btn btn-primary me-2" :disabled="dealerInfoSubmitting">
										<span v-if="dealerInfoSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
										{{ dealerInfoSubmitting ? "Saving..." : "Submit" }}
									</button>
									<button type="button" class="btn btn-light" @click="closeDealerInfoModal">Close</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

		<!-- Enquiry Modal -->
		<div class="modal fade" id="enquiryModal" tabindex="-1" aria-labelledby="enquiryModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="enquiryModalLabel">Enquiry</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="submitEnquiry" enctype="multipart/form-data">
							<!-- Device details -->
							<div class="row mb-1" v-if="enquiryDevice">
								<div class="col-md-12">
									<div class="alert alert-light border">
										<strong>Device:</strong> {{ enquiryDevice.uniqueid }}<br>
										<strong>Current Dealer:</strong> {{ enquiryDevice.dealer_name || '-' }}<br>
										<strong>Current Company:</strong> {{ enquiryDevice.company_name || '-' }}
									</div>
								</div>
							</div>

							<!-- Current Dealer (read-only, shown when device selected) -->
							<div class="row" v-if="enquiryDevice">
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Current Dealer<span class="text-danger">*</span></label>
									<input 
										class="form-control" 
										type="text" 
										autocomplete="off"
										disabled
										:value="enquiryDevice.dealer_name || '-'"
									/>
								</div>
							</div>

							<!-- Renewal Type, Year Of Expiry, Amount -->
							<div class="row">
								<div class="col-md-4 form-group mb-2">
									<label class="control-label">Renewal Type</label>
									<select v-model="enquiryForm.renewal_type" class="form-select">
										<option value="">--select--</option>
										<option value="1">Normal</option>
										<option value="2">SIM Change</option>
										<option value="3">Replacement</option>
										<option value="4">Normal SIM Change</option>
									</select>
								</div>
								<div class="col-md-4 form-group mb-2">
									<label class="control-label">Year Of Expiry</label>
									<select v-model="enquiryForm.year_of_expiry" class="form-select">
										<option value="">--select--</option>
										<option value="1">1 Year</option>
										<option value="2">2 Year</option>
									</select>
								</div>
								<div class="col-md-4 form-group mb-2">
									<label class="control-label">Amount</label>
									<input class="form-control" type="number" placeholder="Enter Amount" v-model="enquiryForm.amount" />
								</div>
							</div>

							<div class="row">
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Enquiry By<span class="text-danger">*</span></label>
									<select v-model="enquiryForm.enquiry_by" class="form-select" required @change="onEnquiryByChange">
										<option value="">Select</option>
										<option value="1">Dealer</option>
										<option value="2">Customer</option>
									</select>
								</div>
							</div>

							<div class="row" v-if="enquiryForm.enquiry_by == '1'">
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Enquiry Dealer<span class="text-danger">*</span></label>
									<div class="position-relative">
										<input 
											class="form-control" 
											type="text" 
											placeholder="Search dealer..." 
											v-model="dealerSearch" 
											@input="searchDealer" 
											@focus="showDealerSuggestions = true" 
											@blur="hideDealerSuggestions"
											autocomplete="off"
										/>
										<ul v-if="showDealerSuggestions && filteredDealers.length" 
											class="list-group position-absolute w-100" 
											style="z-index: 10; max-height: 200px; overflow-y: auto;">
											<li v-for="dealer in filteredDealers" 
												:key="dealer.id" 
												class="list-group-item list-group-item-action" 
												@mousedown.prevent="selectDealer(dealer)">
												{{ dealer.first_name }} {{ dealer.last_name }}
											</li>
										</ul>
									</div>
									<div v-if="enquiryForm.selectedDealer" class="mt-2">
										<small class="text-success">
											<i class="icofont icofont-check-circled me-1"></i>
											Selected: <strong>{{ enquiryForm.selectedDealer.first_name }} {{ enquiryForm.selectedDealer.last_name }}</strong>
										</small>
									</div>
									<span v-if="errors.dealer_id" class="text-danger small">{{ errors.dealer_id }}</span>
								</div>
							</div>

							<div class="row" v-if="enquiryForm.enquiry_by == '1'">
								<div class="col-md-12 form-group mb-2">
									<div class="form-check">
										<input type="checkbox" class="form-check-input" id="assignToThisDealer" v-model="enquiryForm.assignToThisDealer" />
										<label class="form-check-label" for="assignToThisDealer">Assign to this dealer</label>
									</div>
								</div>
							</div>

							<!-- Customer selection - existing -->
							<div class="row" v-if="enquiryForm.enquiry_by == '2' && !enquiryForm.isNewCustomer">
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Customer<span class="text-danger">*</span></label>
									<div class="position-relative">
										<input 
											class="form-control" 
											type="text" 
											placeholder="Search customer..." 
											v-model="customerSearch" 
											@input="searchCustomer" 
											@focus="showCustomerSuggestions = true" 
											@blur="hideCustomerSuggestions"
											autocomplete="off"
										/>
										<ul v-if="showCustomerSuggestions && filteredCustomers.length" 
											class="list-group position-absolute w-100" 
											style="z-index: 10; max-height: 200px; overflow-y: auto;">
											<li v-for="cust in filteredCustomers" 
												:key="cust.id" 
												class="list-group-item list-group-item-action" 
												@mousedown.prevent="selectCustomer(cust)">
												{{ cust.company_name }} - <b>{{ cust.mobile }}</b>
											</li>
										</ul>
									</div>
									<div v-if="enquiryForm.selectedCustomer" class="mt-2">
										<small class="text-success">
											<i class="icofont icofont-check-circled me-1"></i>
											Selected: <strong>{{ enquiryForm.selectedCustomer.company_name }}</strong>
										</small>
									</div>
									<div class="mt-2">
										<a href="#" class="small" @click.prevent="enquiryForm.isNewCustomer = true">+ Add new customer</a>
									</div>
									<span v-if="errors.company_id" class="text-danger small">{{ errors.company_id }}</span>
								</div>
							</div>

							<!-- Customer - new (add new customer) -->
							<div class="row" v-if="enquiryForm.enquiry_by == '2' && enquiryForm.isNewCustomer">
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Customer Name<span class="text-danger">*</span></label>
									<input v-model="enquiryForm.customer_name" class="form-control" placeholder="Enter customer name" />
									<span v-if="errors.customer_name" class="text-danger small">{{ errors.customer_name }}</span>
								</div>
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Username<span class="text-danger">*</span></label>
									<input v-model="enquiryForm.username" class="form-control" placeholder="Enter username" />
									<span v-if="errors.username" class="text-danger small">{{ errors.username }}</span>
								</div>
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Password<span class="text-danger">*</span></label>
									<input v-model="enquiryForm.password" type="password" class="form-control" placeholder="Enter password" />
									<span v-if="errors.password" class="text-danger small">{{ errors.password }}</span>
								</div>
								<div class="col-md-12">
									<a href="#" class="small" @click.prevent="enquiryForm.isNewCustomer = false; clearNewCustomerFields()">← Select existing customer</a>
								</div>
							</div>

							<div class="row" v-if="enquiryForm.enquiry_by == '2'">
								<div class="col-md-12 form-group mb-2">
									<label class="control-label">Vehicle No.</label>
									<input
										class="form-control"
										type="text"
										v-model="enquiryForm.vehicle_no"
										:disabled="enquiryVehicleNoLocked"
										placeholder="Enter vehicle number"
										autocomplete="off"
									/>
									<small v-if="enquiryVehicleNoLocked" class="text-muted">From device record (read-only)</small>
									<span v-if="errors.vehicle_no" class="text-danger small d-block mt-1">{{ Array.isArray(errors.vehicle_no) ? errors.vehicle_no[0] : errors.vehicle_no }}</span>
								</div>
							</div>

							<div class="row mt-3">
								<div class="col-md-12">
									<button type="submit" class="btn btn-primary me-2" :disabled="enquirySubmitting">
										<span v-if="enquirySubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
										{{ enquirySubmitting ? "Saving..." : "Submit Enquiry" }}
									</button>
									<button type="button" class="btn btn-light" @click="closeEnquiryModal">Close</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
	name: "All Devices",

	data() {
		return {
			token: "",
			imei: "",
			type: 1,
			imeiSearchTimer: null,
			listing_length: 10,
			devices: [],
			pagination: {},
			from: 0,
			to: 0,
			total: 0,
			active_page_url: null,
			errors: {},
			enquiryModalInstance: null,
			enquiryDevice: null,
			enquiryForm: {
				enquiry_by: '',
				renewal_type: "",
				year_of_expiry: "",
				amount: '',
				vehicle_no: '',
				selectedDealer: null,
				selectedCustomer: null,
				isNewCustomer: false,
				assignToThisDealer: false,
				customer_name: '',
				username: '',
				password: ''
			},
			dealers: [],
			companies: [],
			dealerSearch: '',
			customerSearch: '',
			showDealerSuggestions: false,
			showCustomerSuggestions: false,
			enquirySubmitting: false,
			// Customer Info modal
			customerInfoModalInstance: null,
			customerInfoDevice: null,
			customerInfoForm: { notes: '', status: 1 },
			customerInfoSubmitting: false,
			// Dealer Info modal
			dealerInfoModalInstance: null,
			dealerInfoDevice: null,
			dealerInfoForm: { notes: '', status: 1 },
			dealerInfoSubmitting: false,
			refreshIntervalId: null,
		};
	},

	mounted() {
		const el = document.getElementById('enquiryModal');
		if (el) this.enquiryModalInstance = new Modal(el);
		const customerInfoEl = document.getElementById('customerInfoModal');
		if (customerInfoEl) this.customerInfoModalInstance = new Modal(customerInfoEl);
		const dealerInfoEl = document.getElementById('dealerInfoModal');
		if (dealerInfoEl) this.dealerInfoModalInstance = new Modal(dealerInfoEl);
	},

	computed: {
		filteredDealers() {
			if (!this.dealerSearch.trim()) return this.dealers;
			const q = this.dealerSearch.toLowerCase();
			return this.dealers.filter(d => (d.first_name || '').toLowerCase().includes(q));
		},
		filteredCustomers() {
			if (!this.customerSearch.trim()) return this.companies;
			const q = this.customerSearch.toLowerCase();
			return this.companies.filter(c => (c.company_name || '').toLowerCase().includes(q));
		},
		enquiryVehicleNoLocked() {
			if (!this.enquiryDevice) return false;
			const v = this.enquiryDevice.vehicle_no;
			return v != null && String(v).trim() !== '';
		}
	},

	created() {
		if (this.$route.query.imei) {
			this.imei = this.$route.query.imei;
		}
		this.fetchDevices();
		this.startRefreshInterval();
	},

	beforeUnmount() {
		this.clearRefreshInterval();
	},

	methods: {
		getToken() {
			if (localStorage.getItem("airotrack_staff")) {
				const airotrack_staff = JSON.parse(localStorage.getItem("airotrack_staff"));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
					this.user = airotrack_staff;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},

		applyApiValidationErrors(apiData) {
			const message = apiData?.message;
			const errors = apiData?.errors;
			if (message && typeof message === "object" && !Array.isArray(message)) {
				this.errors = message;
				return;
			}
			if (errors && typeof errors === "object" && !Array.isArray(errors)) {
				this.errors = errors;
			}
		},

		getApiErrorMessage(apiData, fallback = "Failed to submit enquiry") {
			const pickFirst = (obj) => {
				if (!obj || typeof obj !== "object") return "";
				const firstKey = Object.keys(obj)[0];
				if (!firstKey) return "";
				const value = obj[firstKey];
				if (Array.isArray(value)) return value[0] || "";
				if (typeof value === "string") return value;
				return "";
			};

			if (typeof apiData?.message === "string" && apiData.message.trim()) return apiData.message;
			if (apiData?.message && typeof apiData.message === "object") {
				const msg = pickFirst(apiData.message);
				if (msg) return msg;
			}
			if (apiData?.errors && typeof apiData.errors === "object") {
				const msg = pickFirst(apiData.errors);
				if (msg) return msg;
			}
			return fallback;
		},

		buildQueryString(pageUrl = null) {
			const params = new URLSearchParams();
			params.append("limit", this.listing_length);
			if (this.imei && this.imei.trim()) {
				params.append("imei", this.imei.trim());
			}
			if (pageUrl) {
				const pageMatch = pageUrl.match(/[?&]page=(\d+)/);
				if (pageMatch) {
					params.append("page", pageMatch[1]);
				}
			}
			if (this.type) {
				params.append("type", this.type);
			}
			return "/staffs/getAllDevices?" + params.toString();
		},

		buildPageUrl(paginationPageUrl) {
			if (!paginationPageUrl) return this.buildQueryString();
			const pageMatch = paginationPageUrl.match(/[?&]page=(\d+)/);
			const params = new URLSearchParams();
			params.append("limit", this.listing_length);
			if (this.imei && this.imei.trim()) {
				params.append("imei", this.imei.trim());
			}
			if (pageMatch) {
				params.append("page", pageMatch[1]);
			}
			if (this.type) {
				params.append("type", this.type);
			}
			return "/staffs/getAllDevices?" + params.toString();
		},

		onImeiSearch() {
			if (this.imeiSearchTimer) clearTimeout(this.imeiSearchTimer);
			this.imeiSearchTimer = setTimeout(() => {
				this.fetchDevices();
				this.imeiSearchTimer = null;
			}, 400);
		},

		startRefreshInterval() {
			this.clearRefreshInterval();
			this.refreshIntervalId = setInterval(() => {
				this.fetchDevices(this.active_page_url || undefined);
			}, 20000);
		},

		clearRefreshInterval() {
			if (this.refreshIntervalId) {
				clearInterval(this.refreshIntervalId);
				this.refreshIntervalId = null;
			}
		},

		fetchDevices(page_url = null) {
			this.getToken();
			const url = this.buildQueryString();
			page_url = page_url || url;
			this.active_page_url = page_url;
			this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const responseData = res.data.data;
					if (responseData && responseData.devices) {
						this.devices = responseData.devices.data || [];
						this.pagination = responseData.devices.links || [];
						this.from = responseData.devices.from ?? 0;
						this.to = responseData.devices.to ?? 0;
						this.total = responseData.devices.total ?? 0;
					} else {
						this.devices = [];
						this.pagination = [];
						this.from = 0;
						this.to = 0;
						this.total = 0;
					}
				})
				.catch((err) => {
					console.log(err);
					this.devices = [];
					this.pagination = [];
					this.from = 0;
					this.to = 0;
					this.total = 0;
				});
		},

		confirmExtension(device) {
			this.$swal({
				icon: "warning",
				title: "Confirm",
				text: "Are you sure you want to proceed to extension?",
				showCancelButton: true,
				confirmButtonText: "Yes",
				confirmButtonColor: "#ef5350",
				cancelButtonText: "No",
				position: "center",
				showConfirmButton: true,
				timer: "",
				toast: false,
				cancelButtonColor: "#e0e0e0",
			}).then((result) => {
				if (result.value) {
					this.$router.push({
						name: "device_extension",
						params: { device_id: device.device_id },
					});
				}
			});
		},

		confirmTopup(device) {
			this.$swal({
				icon: "warning",
				title: "Confirm",
				text: "Are you sure you want to proceed to topup?",
				showCancelButton: true,
				confirmButtonText: "Yes",
				confirmButtonColor: "#343a40",
				cancelButtonText: "No",
				position: "center",
				showConfirmButton: true,
				timer: "",
				toast: false,
				cancelButtonColor: "#e0e0e0",
			}).then((result) => {
				if (result.value) {
					this.$router.push({
						name: "device_topup",
						params: { device_id: device.device_id },
					});
				}
			});
		},

		canShowTopup(device) {
			if (!device || Number(device.status) !== 1 || !device.expirationtime) {
				return false;
			}
			const expiry = new Date(device.expirationtime);
			if (Number.isNaN(expiry.getTime())) {
				return false;
			}
			return expiry.getTime() > Date.now();
		},

		canShowExtension(device) {
			if (!device || Number(device.request_status) !== 2 || Number(device.status) === 4) {
				return false;
			}
			if (!device.expirationtime) {
				return false;
			}
			const expiry = new Date(device.expirationtime);
			if (Number.isNaN(expiry.getTime())) {
				return false;
			}
			return expiry.getTime() >= Date.now();
		},

		sendEnquiry(device) {
			this.enquiryDevice = device;
			this.enquiryForm.enquiry_by = '';
			this.enquiryForm.renewal_type = '';
			this.enquiryForm.year_of_expiry = '';
			this.enquiryForm.amount = '';
			this.enquiryForm.vehicle_no = '';
			this.syncEnquiryVehicleNoFromDevice();
			this.enquiryForm.selectedDealer = null;
			this.enquiryForm.selectedCustomer = null;
			this.enquiryForm.isNewCustomer = false;
			this.enquiryForm.assignToThisDealer = false;
			this.clearNewCustomerFields();
			this.dealerSearch = '';
			this.customerSearch = '';
			this.errors = {};

			// Fetch both dealers and companies, then apply auto-selection
			Promise.all([this.fetchDealers(), this.fetchCompanies()]).then(() => {
				// Auto-select will be applied when user selects enquiry_by in onEnquiryByChange
				// Pre-select first option if device has data
				if (device.dealer_id) {
					const dealer = this.dealers.find(d => d.id == device.dealer_id);
					if (dealer) {
						this.enquiryForm.selectedDealer = dealer;
						this.dealerSearch = dealer.first_name;
					}
				}
				if (device.company_id) {
					const cust = this.companies.find(c => c.id == device.company_id);
					if (cust) {
						this.enquiryForm.selectedCustomer = cust;
						this.customerSearch = cust.company_name;
					}
				}
			});

			if (this.enquiryModalInstance) this.enquiryModalInstance.show();
		},

		fetchDealers() {
			this.getToken();
			return this.$axios
				.get("/staffs/dealers", { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const data = res.data.data || res.data;
					this.dealers = Array.isArray(data) ? data : (data.data || []);
					return this.dealers;
				})
				.catch((err) => {
					console.log(err);
					this.dealers = [];
					return [];
				});
		},

		fetchCompanies() {
			this.getToken();
			return this.$axios
				.get("/staffs/companies", { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const data = res.data.data || res.data;
					this.companies = Array.isArray(data) ? data : (data.data || []);
					return this.companies;
				})
				.catch((err) => {
					console.log(err);
					this.companies = [];
					return [];
				});
		},

		searchDealer() {
			this.showDealerSuggestions = true;
		},
		searchCustomer() {
			this.showCustomerSuggestions = true;
		},
		hideDealerSuggestions() {
			setTimeout(() => { this.showDealerSuggestions = false; }, 200);
		},
		hideCustomerSuggestions() {
			setTimeout(() => { this.showCustomerSuggestions = false; }, 200);
		},
		selectDealer(dealer) {
			this.enquiryForm.selectedDealer = dealer;
			this.dealerSearch = dealer.first_name;
			this.showDealerSuggestions = false;
		},
		selectCustomer(cust) {
			this.enquiryForm.selectedCustomer = cust;
			this.customerSearch = cust.company_name;
			this.showCustomerSuggestions = false;
		},

		onEnquiryByChange() {
			this.enquiryForm.selectedDealer = null;
			this.enquiryForm.selectedCustomer = null;
			this.enquiryForm.isNewCustomer = false;
			this.enquiryForm.assignToThisDealer = false;
			this.dealerSearch = '';
			this.customerSearch = '';
			this.clearNewCustomerFields();
			// Re-apply auto-selection based on device
			if (this.enquiryDevice) {
				if (this.enquiryForm.enquiry_by == '1' && this.enquiryDevice.dealer_id) {
					const dealer = this.dealers.find(d => d.id == this.enquiryDevice.dealer_id);
					if (dealer) {
						this.enquiryForm.selectedDealer = dealer;
						this.dealerSearch = dealer.first_name;
					}
				}
				if (this.enquiryForm.enquiry_by == '2' && this.enquiryDevice.company_id) {
					const cust = this.companies.find(c => c.id == this.enquiryDevice.company_id);
					if (cust) {
						this.enquiryForm.selectedCustomer = cust;
						this.customerSearch = cust.company_name;
					}
				}
			}
			if (this.enquiryForm.enquiry_by == '2') {
				this.syncEnquiryVehicleNoFromDevice();
			} else {
				this.enquiryForm.vehicle_no = '';
			}
		},

		syncEnquiryVehicleNoFromDevice() {
			if (!this.enquiryDevice) {
				this.enquiryForm.vehicle_no = '';
				return;
			}
			const v = this.enquiryDevice.vehicle_no;
			if (v != null && String(v).trim() !== '') {
				this.enquiryForm.vehicle_no = String(v).trim();
			} else {
				this.enquiryForm.vehicle_no = '';
			}
		},

		clearNewCustomerFields() {
			this.enquiryForm.customer_name = '';
			this.enquiryForm.username = '';
			this.enquiryForm.password = '';
		},

		closeEnquiryModal() {
			if (this.enquiryModalInstance) this.enquiryModalInstance.hide();
			this.enquiryDevice = null;
			this.enquiryForm.enquiry_by = '';
			this.enquiryForm.renewal_type = '';
			this.enquiryForm.year_of_expiry = '';
			this.enquiryForm.amount = '';
			this.enquiryForm.vehicle_no = '';
			this.enquiryForm.selectedDealer = null;
			this.enquiryForm.selectedCustomer = null;
			this.enquiryForm.isNewCustomer = false;
			this.enquiryForm.assignToThisDealer = false;
			this.clearNewCustomerFields();
			this.dealerSearch = '';
			this.customerSearch = '';
			this.errors = {};
		},

		submitEnquiry() {
			this.getToken();
			this.errors = {};
			this.enquirySubmitting = true;

			const deviceId = this.enquiryDevice?.device_id || this.enquiryDevice?.id;
			if (!deviceId) {
				this.$swal("", "Device not found", "error");
				this.enquirySubmitting = false;
				return;
			}

			let payload = {
				device_id: deviceId,
				enquiry_by: this.enquiryForm.enquiry_by
			};
			// Always send these fields as strings; backend expects keys present (not null/undefined).
			{
				const rt = this.enquiryForm.renewal_type;
				payload.renewal_type = (rt === null || rt === undefined || rt === "") ? "" : rt;
			}
			{
				const y = this.enquiryForm.year_of_expiry;
				payload.year_of_expiry = (y === null || y === undefined || y === "") ? "" : y;
			}
			// Always send amount: empty string when not set (backend expects key present, not null)
			{
				const a = this.enquiryForm.amount;
				if (a === null || a === undefined || a === "") {
					payload.amount = "";
				} else if (typeof a === "string" && a.trim() === "") {
					payload.amount = "";
				} else {
					payload.amount = a;
				}
			}

			if (this.enquiryForm.enquiry_by == '1') {
				if (!this.enquiryForm.selectedDealer) {
					this.errors.dealer_id = "Please select a dealer";
					this.enquirySubmitting = false;
					return;
				}
				payload.dealer_id = this.enquiryForm.selectedDealer.id;
				payload.is_assign = this.enquiryForm.assignToThisDealer ? 1 : 2;
			} else if (this.enquiryForm.enquiry_by == '2') {
				if (this.enquiryForm.isNewCustomer) {
					if (!this.enquiryForm.customer_name?.trim()) {
						this.errors.customer_name = "Customer name is required";
						this.enquirySubmitting = false;
						return;
					}
					if (!this.enquiryForm.username?.trim()) {
						this.errors.username = "Username is required";
						this.enquirySubmitting = false;
						return;
					}
					if (!this.enquiryForm.password?.trim()) {
						this.errors.password = "Password is required";
						this.enquirySubmitting = false;
						return;
					}
					payload.customer_name = this.enquiryForm.customer_name.trim();
					payload.username = this.enquiryForm.username.trim();
					payload.password = this.enquiryForm.password;
				} else {
					if (!this.enquiryForm.selectedCustomer) {
						this.errors.company_id = "Please select a customer";
						this.enquirySubmitting = false;
						return;
					}
					payload.company_id = this.enquiryForm.selectedCustomer.id;
				}
				payload.vehicle_no = (this.enquiryForm.vehicle_no || '').trim();
			} else {
				this.$swal("", "Please select enquiry by (Dealer or Customer)", "error");
				this.enquirySubmitting = false;
				return;
			}

			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + this.token,
				},
			};

			this.$axios
				.post("/staffs/enquiryRequest", payload, config)
				.then((response) => {
					if (response.data.status) {
						this.$swal("", response.data.message || "Enquiry submitted successfully", "success");
						this.closeEnquiryModal();
						this.fetchDevices(this.active_page_url);
					} else {
						this.applyApiValidationErrors(response.data);
						this.$swal("", this.getApiErrorMessage(response.data), "error");
					}
					this.enquirySubmitting = false;
				})
				.catch((error) => {
					this.enquirySubmitting = false;
					if (error.response) {
						const apiData = error.response.data || {};
						this.applyApiValidationErrors(apiData);
						this.$swal("", this.getApiErrorMessage(apiData, "Something went wrong"), "error");
					} else {
						this.$swal("", "Something went wrong", "error");
					}
				});
		},

		customerInfo(device) {
			this.getToken();
			this.customerInfoDevice = device;
			this.customerInfoForm.notes = '';
			this.customerInfoForm.status = 1;
			if (this.customerInfoModalInstance) this.customerInfoModalInstance.show();
		},

		closeCustomerInfoModal() {
			if (this.customerInfoModalInstance) this.customerInfoModalInstance.hide();
			this.customerInfoDevice = null;
			this.customerInfoForm.notes = '';
			this.customerInfoForm.status = 1;
		},

		submitCustomerInfo() {
			if (!this.customerInfoDevice) return;
			this.getToken();
			this.customerInfoSubmitting = true;
			const deviceId = this.customerInfoDevice.device_id || this.customerInfoDevice.id;
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + this.token,
				},
			};
			const payload = {
				device_id: deviceId,
				customer_status: this.customerInfoForm.status,
				customer_info_notes: this.customerInfoForm.notes || '',
			};
			this.$axios
				.post("/staffs/markCustomerInfo", payload, config)
				.then((response) => {
					if (response.data.status) {
						this.$swal("", response.data.message || "Saved successfully", "success");
						this.closeCustomerInfoModal();
						this.fetchDevices(this.active_page_url);
					} else {
						this.$swal("", response.data.message || "Failed to save", "error");
					}
					this.customerInfoSubmitting = false;
				})
				.catch((error) => {
					this.customerInfoSubmitting = false;
					if (error.response && error.response.data.message) {
						this.$swal("", error.response.data.message, "error");
					} else {
						this.$swal("", "Something went wrong", "error");
					}
				});
		},

		dealerInfo(device) {
			this.getToken();
			this.dealerInfoDevice = device;
			this.dealerInfoForm.notes = '';
			this.dealerInfoForm.status = 1;
			if (this.dealerInfoModalInstance) this.dealerInfoModalInstance.show();
		},

		closeDealerInfoModal() {
			if (this.dealerInfoModalInstance) this.dealerInfoModalInstance.hide();
			this.dealerInfoDevice = null;
			this.dealerInfoForm.notes = '';
			this.dealerInfoForm.status = 1;
		},

		submitDealerInfo() {
			if (!this.dealerInfoDevice) return;
			this.getToken();
			this.dealerInfoSubmitting = true;
			const deviceId = this.dealerInfoDevice.device_id || this.dealerInfoDevice.id;
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + this.token,
				},
			};
			const payload = {
				device_id: deviceId,
				dealer_status: this.dealerInfoForm.status,
				dealer_info_notes: this.dealerInfoForm.notes || '',
			};
			this.$axios
				.post("/staffs/markDealerInfo", payload, config)
				.then((response) => {
					if (response.data.status) {
						this.$swal("", response.data.message || "Saved successfully", "success");
						this.closeDealerInfoModal();
						this.fetchDevices(this.active_page_url);
					} else {
						this.$swal("", response.data.message || "Failed to save", "error");
					}
					this.dealerInfoSubmitting = false;
				})
				.catch((error) => {
					this.dealerInfoSubmitting = false;
					if (error.response && error.response.data.message) {
						this.$swal("", error.response.data.message, "error");
					} else {
						this.$swal("", "Something went wrong", "error");
					}
				});
		},
	},
};
</script>
